import * as React from 'react';
import { DataGrid, GridApi, GridCellValue, GridColDef } from '@mui/x-data-grid';
import { Card, Icon, IconButton, LinearProgress, Tooltip } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';

interface IGridviewProps {
    rowId: any;
    rows: any[];
    columns: GridColDef[];
    actions: IActions[];
    loading: boolean;
}

export interface IActions {
    field: string;
    headerName: string;
    icon: string;
    iconToolTip: string;
    iconColor: string;
    setAction: (value: string) => void;
}

export const Gridview: React.FC<IGridviewProps> = ({ rows, columns, actions, rowId, loading }) => {

    const [columnsGrid, setColumnsGrid] = useState<GridColDef[]>([]);

    useEffect(() => {
        let actionColumns: any[] = [];

        actionColumns = createActions(actions);

        columns.forEach(column => {
            actionColumns.push(column);
        });
        setColumnsGrid(actionColumns);
    }, []);


    return (
        <div style={{ height: '100%', width: '100%' }}>
            {loading && (
                <LinearProgress sx={{ borderRadius: 3, mb: 1 }} />
            )}
            <Card sx={{ display: 'flex', width: '100%', height: '800px', borderRadius: 2, p: 2 }}>
                <DataGrid
                    getRowId={(row => row.id)}
                    rows={rows}
                    columns={columnsGrid}
                    pageSize={20}
                    rowsPerPageOptions={[20]}
                    disableSelectionOnClick
                    sx={{
                        border: 0,
                        rowGap: 0
                    }}
                />
            </Card>
        </div>
    );
};

function createActions(actions: any[]) {

    const actionColumns: GridColDef[] = [];

    actions.map((action, index) => {
        actionColumns.push(
            {
                field: action.field,
                headerName: action.headerName,
                sortable: false,
                width: 40,
                filterable: false,
                hideable: false,
                disableColumnMenu: true,
                align: 'center',
                renderCell: (params) => {
                    const onClick = (e: any) => {
                        e.stopPropagation(); // don't select this row after clicking

                        const api: GridApi = params.api;

                        const thisRow: Record<string, GridCellValue> = {};

                        api
                            .getAllColumns()
                            .filter((c) => c.field !== '__check__' && !!c)
                            .forEach(
                                (c) => (thisRow[c.field] = params.getValue(params.id, c.field))
                            );
                        return action.setAction(JSON.stringify(thisRow, null, 4));
                    };
                    return (
                        <Box display={'flex'} >
                            <Tooltip
                                title={action.iconToolTip}
                            >
                                <IconButton onClick={onClick}>
                                    <Icon fontSize='medium' color={action.iconColor} >{action.icon}</Icon>
                                </IconButton>
                            </Tooltip>
                        </Box>
                    );
                }
            }
        );
    });

    return (
        actionColumns ?? undefined
    );
}

